



















































































































































import { mapActions, mapState } from 'vuex';
import { isEmpty } from 'lodash-es';

import {
  sortOptions,
  statusOptions,
  pageLimitOptions,
} from '@adobe/edex/frontend/views/externalCourse/manage/constants';
import Pagination from '@adobe/edex/frontend/views/course/manage/numbered-pagination.vue';
import TableRow from '@adobe/edex/frontend/views/externalCourse/manage/externalCourse-manage-row.vue';
import BulkActions from '@adobe/edex/frontend/views/externalCourse/manage/externalCourse-manage-bulk-actions.vue';
import Select from '@adobe/edex/frontend/views/course/manage/course-manage-select.vue';
import { paginateMixin } from '@adobe/edex/frontend/mixins/paginate';
import '@adobe/edex/ui/shared/components/dialog-next/import-result-dialog';
import '@adobe/edex/ui/shared/components/dialog-next/import-details-dialog';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import Vue from 'vue';

export default {
  data() {
    return {
      selected: new Set(),
      showSort: false,
      showStatus: false,
      showLimit: false,
      error: false,
      searchTerm: '',
      lastSearch: '',
      sort: 'updatedAt',
      status: null,
      flagged: false,
      limit: 25,
      page: 1,
      offset: 0,
      maxPage: 1,
      bulkErrors: 0,
      exportError: false,
      sortOptions,
      statusOptions,
      pageLimitOptions,
    };
  },
  components: {
    TableRow,
    BulkActions,
    Pagination,
    Select,
  },
  mixins: [paginateMixin],
  async created() {
    this.list();
  },
  computed: {
    ...mapState('externalAssignmentModule', ['assignment']),
    ...mapState('externalCourseModule', ['externalCourse']),
    ...mapState('member', ['member']),
    showMore() {
      return this.assignment?.meta.hasMore;
    },
    getSearchTransalation() {
      return $t('i18n.course.enrollees.Search_Placeholder').toString();
    },
    allSelected() {
      const pendingReviewAssignments = this.getPendingReviewAssignments().length;
      const selectedCount = this.selected.size;
      return Boolean(this.assignment.data) && selectedCount === pendingReviewAssignments && selectedCount > 0;
    },

    loading() {
      return this.requests.assignment?.loading;
    },
    searchApplied() {
      return Boolean(this.lastSearch) && this.searchTerm == this.lastSearch;
    },
  },
  methods: {
    ...mapActions('externalAssignmentModule', ['fetchExternalAssignments']),
    async list() {
      this.error = false;
      try {
        const params = {
          limit: this.limit,
          offset: this.offset,
          shell_course_id: this.externalCourse.shell_course_id,
          fileUploadStatus: !isEmpty(this.status) ? this.status : null,
          orderBy: this.sort.startsWith('-') ? this.sort.slice(1) : this.sort,
          orderType: this.sort.startsWith('-') ? 'ASC' : 'DESC'
        };
        await this.fetchExternalAssignments(params);
        this.selected = new Set();
        this.lastSearch = this.searchTerm;
        this.maxPage = Math.ceil(this.assignment.meta.totalRecords / this.limit);
      } catch (error) {
        console.log('error', error);
        this.error = true;
      }
    },
    canViewManageTab() {
      const staffIds = this.externalCourse.staff.map((staff) => staff.id);
      return this.member?.isAdmin || this.member?.isShellCourseAdmin || ( this.member?.isShellCourseAssignmentReviewer && staffIds.includes(this.member?.id));
    },
    getPendingReviewAssignments() {
      const pendingReviewAssignments = this.assignment.data.filter((assign) => assign.status === 'pending-review');
      return pendingReviewAssignments;
    },
    onPageChanged(page) {
      this.page = page;
      this.offset = (page - 1) * this.limit;
      this.list();
    },
    selectAll() {
      if (this.allSelected) {
        this.selected = new Set();
      } else {
        const pendingReviewAssignments = this.getPendingReviewAssignments()
        .map((assign) => assign.assignment_id);
        this.selected = new Set(pendingReviewAssignments);
        if(isEmpty(this.selected)) {
          Vue.toasted.error("Noting to select, no assignments with pending review status!");
        }
      }
    },
    onTextSearch() {
      this.offset = 0;
      this.page = 1;
      this.list();
    },
    resetSearchTerm() {
      this.searchTerm = '';
      this.offset = 0;
      this.page = 1;
      this.list();
    },
    onFilterSelected(filter, value) {
      if (this[filter] === value) {
        this[filter] = '';
      } else {
        this[filter] = value;
      }
      this.onFiltersChanged();
    },
    onFiltersChanged() {
      this.offset = 0;
      this.page = 1;
      this.list();
    },
    clearFilters() {
      this.status = '';
      this.onFiltersChanged();
    },
    onBulkActionSuccess(assignment) {
      assignment.forEach((assignmentexternal) => this.onRowUpdated(assignmentexternal));
    },
    onRowUpdated(assignment) {
      this.assignment.data.forEach((data) => {
        if (data.assignment_id === assignment.assignment_id) {
          data.status = assignment.status;
          data.awarded = assignment.awarded;
        }
      });
    },
    onRowSelected(id) {
      this.selected.add(id);
      this.selected = new Set(this.selected);
    },
    onRowUnselected(id) {
      this.selected.delete(id);
      this.selected = new Set(this.selected);
    },
    onBulkError(count) {
      this.bulkErrors = count;
      this.list();
    },
  },
};
